export default __webpack_public_path__ + "static/media/A5_ORI.33e6b5cf.png";